import { IRequestBody } from './types.ts';
import { FeedBack } from '@/utils/feed_back.ts'
import { SERVER_TYPE, DEBUG_ENV, API_URL, KEEP_STORE_NAME, DEFAULT_ANTI_SPIDER, CHANNEL_TYPE, SM_SERVER_TYPE, SDK_VERSION, METRIC_NAME_F, METRIC_NAME_COMMON_INFO_CHANGED } from '@/constants/index.ts';
import { generateMonitorReport } from '@shein-aidc/monitor-core/monitor-report';
import sdkInit, { provider } from './init';
import verify from './verify';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global.ts';
import { AxiosResponse } from 'axios';
import { rewriteFetch, rewriteXHR, fetchJsonSafe } from '@/utils';
import logUtils from '@/utils/logUtils.ts';
import metricReporter from '@/utils/metricReporter';
import { smartReport } from '@/utils/metricHelper';
export class AntiSpiderManager {
  private static instance: AntiSpiderManager;
  private feedback: FeedBack | any = null;
  private server_type: keyof typeof SERVER_TYPE.production = 'central'; //数据中心
  private env: keyof typeof DEBUG_ENV = 'production'; //环境
  private headers: object = {}; //请求头
  private keep_store: boolean = true //是否允许存储
  private brand: 'shein' | 'romwe' = 'shein' //品牌
  private currency: string = 'USD' //货币
  private language: string = 'en' //语言
  private device_type: 'pc' | 'h5' | 'pwa' = 'pc' //设备类型
  private site_id: string = '' //品牌ID
  private site_from: string = '' //站点
  // private api_paths: string[] = ['/bff-api', '/api', '/risk'] //请求路径
  private sdks: string[] = ['csrandom', 'anti_in', 'infp', 'sm', 'main', 'td'] //sdk
  private needSdks: string[] = [] //sdk
  private validate_channel: string = '0' //验证通道
  private validate_scene: string = 'anti_crawler_RT' //验证场景
  // private limit_init_count: number = 0 //限制初始化次数
  private limit_init_max: number = 1 //限制初始化最大次数
  private cancel_sdks_headers: string[] = [] // 需要排除的请求头
  private site_id_slim: string = '' // 站点细分
  private mirror: { [key: string]: string } = {} // 镜像参数
  private apiHost: string = '' // 接口地址
  private constructor() { }
  public init(options: IRequestBody) {
    window.__limit_init_count = (window.__limit_init_count || 0) + 1;
    const { validate_channel = '0', validate_param } = options
    if (!validate_param?.server_type || !validate_param?.site_id || !validate_param?.site_from || !validate_param?.language) return;
    this.server_type = validate_param?.server_type || this.server_type;
    this.env = validate_param?.env || this.env;
    this.keep_store = validate_param?.keep_store || this.keep_store;
    this.currency = validate_param?.currency || this.currency;
    this.language = validate_param?.language || this.language;
    this.device_type = CHANNEL_TYPE[validate_channel] || this.device_type;
    this.site_id = validate_param?.site_id || this.site_id;
    this.site_from = validate_param?.site_from || this.site_from;
    this.brand = validate_param?.brand || this.brand;
    this.validate_channel = validate_channel;
    this.headers = validate_param?.headers || this.headers;
    this.site_id_slim = validate_param?.site_id_slim || this.site_id_slim;
    // if (Array.isArray(validate_param?.api_paths)) {
    //   this.api_paths = Array.from(new Set([...this.api_paths, ...validate_param?.api_paths]));
    // }
    this.apiHost = validate_param?.infp?.api_host || this.apiHost;
    this.mirror = validate_param?.mirror || this.mirror;
    this.sdks = validate_param?.sdks || this.sdks;
    this.needSdks = [...this.sdks];
    if (validate_param?.pay?.switch === 'open') {
      this.sdks.push('cybersource', 'forter', 'riskified');
      this.needSdks.push('pay');
    }
    this.cancel_sdks_headers = validate_param?.cancel_sdks_headers || this.cancel_sdks_headers;
    GlobalVariables.set(GLOBAL_VARIABLES.ENV, this.env);
    // GlobalVariables.set(GLOBAL_VARIABLES.API_PATHS, this.api_paths);
    GlobalVariables.set(GLOBAL_VARIABLES.CHANNEL, this.validate_channel);

    let store_data: any = {};
    try {
      store_data = JSON.parse(window?.localStorage?.getItem(KEEP_STORE_NAME) as string) || DEFAULT_ANTI_SPIDER;
      GlobalVariables.set(GLOBAL_VARIABLES.ANTI_HIT, store_data?.anti_in?.hit || []);
      GlobalVariables.set(GLOBAL_VARIABLES.CS_HIT, store_data?.csrandom?.hit || []);
    } catch (error) {
      console.log('localStorage parse error', error);
      store_data = DEFAULT_ANTI_SPIDER
    }
    this.initLog();
    this.initH5InfpAndSm();
    this.initXHRAndFetch(this.cancel_sdks_headers, this.sdks, this.mirror);
    this.loadScripts(store_data, validate_channel);
    this.loadSDK();
  }

  private initLog() {
    const { metric } = generateMonitorReport(
      {
        app_name: this.brand,
        device_type: this.device_type,
        sub_site: this.site_from,
        money_type: this.currency,
        language: this.language,
        environment: this.env === 'production' ? 'production' : 'debug'
      },
      {
        server_type: this.server_type
      }
    )
    metricReporter.setMetricFunction(metric);
  }

  private initXHRAndFetch(_headers: string[], _sdks: string[], _mirror: { [key: string]: string } = {}) {
    if (window.__limit_init_count > this.limit_init_max) {
      logUtils.info('Initialization limit reached', `Current: ${window.__limit_init_count}  Max: ${this.limit_init_max} Please check for repeated initializations.`);
      return;
    };
    rewriteXHR(_headers, _sdks, _mirror);
    rewriteFetch(_headers, _sdks)
  }

  private async loadSDK() {
    const url = `${SERVER_TYPE[this.env][this.server_type]}${API_URL.VALIDATION_ANTI_SPIDER}`;
    const params = {
      v: SDK_VERSION,
      sdk: this.sdks,
      site_id: this.site_id,
      site_from: this.site_from,
      channel: this.validate_channel,
      scene: this.validate_scene
    };
    try {
      const { response, status } = await fetchJsonSafe(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      });
      if (response?.code === '0') {
        window?.localStorage?.setItem(KEEP_STORE_NAME, JSON.stringify(response?.info || {}));
        GlobalVariables.set(GLOBAL_VARIABLES.ANTI_HIT, response?.info?.anti_in?.hit || []);
        GlobalVariables.set(GLOBAL_VARIABLES.CS_HIT, response?.info?.csrandom?.hit || []);
      }
      smartReport({
        metric_name: METRIC_NAME_F,
        tags: { url, status, type: 'loadSDK', ...params },
        value: 1,
        message: 'spider load success',
      })
    } catch (error: any) {
      smartReport({
        metric_name: METRIC_NAME_F,
        tags: { url, status: error?.status, type: 'loadSDKError', ...params },
        value: 1,
        message: 'spider load error',
        params: error
      })
    }
  }

  public async doVerify(options: Record<string, any>, callback: (data: any) => void, _headers?: Record<string, any>): Promise<any> {
    const { validate_param, validate_type, validate_channel, validate_scene } = options
    if (!validate_type) return Promise.resolve({});
    const obj = {
      baseURL: `${SERVER_TYPE[this.env][this.server_type]}`,
      site_id: validate_param?.site_id || this.site_id,
      site_from: validate_param?.site_from || this.site_from,
      language: validate_param?.language || this.language,
      headers: _headers || this.headers,
      validate_type,
      validate_scene: validate_scene,
      validate_channel: validate_channel || this.validate_channel,
      validate_param: validate_param || {},
      twice_check: false,
      site_id_slim: this.site_id_slim,
      s_options: options
    }
    return verify(obj).then((data) => {
      callback?.(data);
    }).catch((err) => {
      callback?.(err);
    });
  }

  private async loadScripts(data: any, channel: string) {
    window['_INCONF'] = {
      appName: this.brand,
      apiHost: this.apiHost || `${SERVER_TYPE[this.env][this.server_type]}`,
      channel,
      isOpenIntervalReport: false,
      isOpenFeatureDector: false,
      onsuccess: () => {
        const armorToken = window?.AntiDevices?.getArmorToken()
        if (armorToken) {
          window.__ArmorToken = armorToken
          window?.sessionStorage?.setItem('armorToken', armorToken)
          window?.localStorage?.setItem('armorToken', armorToken)
        }
      }
    }
    window['_smConf'] = {
      organization: 'FPNyuLhAtVnAeldjikus',
      isOpenUserBehavior: false,
      apiHost: `${SM_SERVER_TYPE[this.env][this.server_type]}/risk/verify/identity/validation/devices`,
    }
    const needLoadSDK = {} as typeof import('@/constants')['DEFAULT_ANTI_SPIDER']
    if (Array.isArray(this.sdks) && this.sdks.length > 0) {
      // // 支付不参与初始化JS加载
      // const filteredSdks = this.sdks.filter(s => !this.pay_collection.includes(s));
      // filteredSdks.forEach((sdk: string) => {
      this.needSdks.forEach((sdk: string) => {
        if (sdk == "pay") {
          needLoadSDK[sdk] = data
        } else {
          if (data[sdk]) {
            needLoadSDK[sdk] = data[sdk]
          }
        }
      })
    }
    sdkInit(needLoadSDK, { server_type: this.server_type, env: this.env, site_from: this.site_from, brand: this.brand, channel });
  }
  public antiSpiderInterceptor() {
    if (!AntiSpiderManager.instance.feedback) {
      const anti_spider = {
        name: 'anti_spider',
        active: () => true,
        range: () => true,
        check: ({ data }) => data?.code == 836100 && data?.sub_code && data?.attachment?.cookie_duration,
        fix: (r: AxiosResponse) => this.runFlowChallenge(r.data.sub_code, r.data.attachment.cookie_duration, r?.headers?.['risk-id'])
          .then((data: any) => { if (data.status !== 'success') { throw data } }),
      }
      AntiSpiderManager.instance.feedback = new FeedBack([anti_spider]);
    }
    return AntiSpiderManager.instance.feedback.interceptor;
  }

  private runFlowChallenge(captcha_type: string, cookie_duration: string, api_risk_id: string) {
    const obj = {
      baseURL: `${SERVER_TYPE[this.env][this.server_type]}`,
      site_id: this.site_id,
      site_from: this.site_from,
      language: this.language,
      validate_type: captcha_type,
      validate_scene: this.validate_scene,
      validate_channel: this.validate_channel,
      validate_param: {
        decision_id: api_risk_id || '',
      },
      headers: this.headers || {},
      cookie_duration,
      site_id_slim: this.site_id_slim
    }
    return verify(obj)
  }

  private async initH5InfpAndSm() {
    if (this.validate_channel == '0' || this.validate_channel == '1') return;
    //h5
    window._s_ArmorToken = await provider.armortoken({ validate_channel: this.validate_channel });
    window._s_SmDeviceId = await provider.smdeviceid();
    try {
      // 监听app headers动态数据变化 app版本 8.8.0 以下不支持
      window?.document?.addEventListener("commonInfoChanged", (data: any = {}) => {
        const params = data.detail || data.param || data || {}
        if (params?.smDeviceId) {
          window._s_SmDeviceId = params?.smDeviceId
        }
        if (params?.armorToken) {
          window._s_ArmorToken = params?.armorToken
        }
        // 事件日志 - 使用延迟上报
        smartReport({
          metric_name: METRIC_NAME_COMMON_INFO_CHANGED,
          tags: { type: 'cic', from: 'document' },
          value: 1,
          message: 'commonInfoChanged',
          params: data
        })
      });

      // 监听app headers动态数据变化 app版本 8.8.0 以下不支持
      window?.addEventListener("commonInfoChanged", (data: any = {}) => {
        const params = data.detail || data.param || data || {}
        if (params?.smDeviceId) {
          window._s_SmDeviceId = params?.smDeviceId
        }
        if (params?.armorToken) {
          window._s_ArmorToken = params?.armorToken
        }
        // 事件日志 - 使用延迟上报
        smartReport({
          metric_name: METRIC_NAME_COMMON_INFO_CHANGED,
          tags: { type: 'cic', from: 'window' },
          value: 1,
          message: 'commonInfoChanged',
          params: data
        })
      });
    } catch (error) {
      // 错误日志 - 使用立即上报
      smartReport({
        metric_name: METRIC_NAME_COMMON_INFO_CHANGED,
        tags: { type: 'cic', from: 'error' },
        value: 1,
        message: 'commonInfoChanged',
        params: error
      })
    }
  }

  public async antiBlackbox() {
    return provider.blackbox({ validate_channel: this.validate_channel, brand: this.brand })
  }

  public async antiSmdeviceid() {
    return provider.smdeviceid()
  }

  public async antiArmortoken() {
    return provider.armortoken({ validate_channel: this.validate_channel })
  }

  public antiin() {
    return provider.antiin()
  }

  public antiPay() {
    return provider.antiPay()
  }

  public static getInstance() {
    if (!AntiSpiderManager.instance) {
      AntiSpiderManager.instance = new AntiSpiderManager();
    }
    return AntiSpiderManager.instance;
  }
}

export default AntiSpiderManager.getInstance();
const init = AntiSpiderManager.getInstance().init.bind(AntiSpiderManager.getInstance());
const doVerify = AntiSpiderManager.getInstance().doVerify.bind(AntiSpiderManager.getInstance());
const antiSpiderInterceptor = AntiSpiderManager.getInstance().antiSpiderInterceptor.bind(AntiSpiderManager.getInstance());
const antiBlackbox = AntiSpiderManager.getInstance().antiBlackbox.bind(AntiSpiderManager.getInstance());
const antiin = AntiSpiderManager.getInstance().antiin.bind(AntiSpiderManager.getInstance());
const antiPay = AntiSpiderManager.getInstance().antiPay.bind(AntiSpiderManager.getInstance());
const antiArmortoken = AntiSpiderManager.getInstance().antiArmortoken.bind(AntiSpiderManager.getInstance());

export {
  init,
  doVerify,
  antiSpiderInterceptor,
  antiBlackbox,
  antiin,
  antiPay,
  antiArmortoken
}
